import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
const cardColors = [
  "#f8f9fa",
  "#e9f7ef",
  "#fcefe3",
  "#eaf2f8",
  "#fdf2f8",
  "#f3f3f3",
];

const priceData = [
  {
    title: "Bella Canvas 3001 Adult Unisex Shirts",
    items: [
      { size: "XS Unisex", price: 9.5, handling: 2 },
      { size: "S-XL Unisex", price: 10, handling: 2 },
      { size: "2XL Unisex", price: 11, handling: 2 },
      { size: "3XL Unisex", price: 13, handling: 2 },
    ],
  },
  {
    title: "Gildan 5000 Adult Unisex Shirts",
    items: [
      { size: "S-XL Unisex", price: 5, handling: 2 },
      { size: "2XL Unisex", price: 7, handling: 2 },
      { size: "3XL Unisex", price: 8, handling: 2 },
    ],
  },
  {
    title: "Comfort Colors 1717 Adult Unisex Shirt",
    items: [
      { size: "S-XL Unisex", price: 12, handling: 2 },
      { size: "2XL Unisex", price: 13, handling: 2 },
      { size: "3XL Unisex", price: 15, handling: 2 },
    ],
  },
  {
    title: "Gildan 18500 Unisex Adult HOODIES",
    items: [
      { size: "S-XL Unisex", price: 15, handling: 2 },
      { size: "2XL Unisex", price: 18, handling: 2 },
      { size: "3XL Unisex", price: 20, handling: 2 },
    ],
  },
  {
    title: "Gildan 18000B Youth SWEATSHIRT",
    items: [{ size: "XS-XL Unisex", price: 12, handling: 2 }],
  },
  {
    title: "Gildan 18000 Adult SWEATSHIRT",
    items: [
      { size: "S-XL Unisex", price: 11, handling: 2 },
      { size: "2XL Unisex", price: 13, handling: 2 },
      { size: "3XL Unisex", price: 14, handling: 2 },
    ],
  },
  {
    title: "YOUTH SIZE SHIRT",
    items: [{ size: "Youth S/M/L/XL", price: 10, handling: 2 }],
  },
  {
    title: "TODDLER",
    items: [{ size: "Toddler 2T-5T", price: 9, handling: 2 }],
  },
  {
    title: "Gildan 3000 Adult Unisex Shirts",
    items: [
      { size: "S-XL Unisex", price: 3, handling: 2 },
      { size: "2XL Unisex", price: 5, handling: 2 },
      { size: "3XL Unisex", price: 6, handling: 2 },
    ],
  },
  {
    title: "RACERBACK TANK",
    items: [
      { size: "XS-XL Unisex", price: 9.5, handling: 2 },
      { size: "2XL Unisex", price: 10, handling: 2 },
    ],
  },
  {
    title: "WOMEN V NECK",
    items: [
      { size: "XS-XL Unisex", price: 9, handling: 2 },
      { size: "2XL Unisex", price: 11, handling: 2 },
      { size: "3XL Unisex", price: 12, handling: 2 },
    ],
  },
  {
    title: "BABY ONE PIECE",
    items: [
      { size: "One Piece 3-6 / 6-12 / 12-18 months", price: 9, handling: 2 },
    ],
  },
  {
    title: "Crop Top",
    items: [
      { size: "XS-XL Unisex", price: 12, handling: 2 },
      { size: "2XL Unisex", price: 13, handling: 2 },
      { size: "3XL Unisex", price: 15, handling: 2 },
    ],
  },
  {
    title: "DTF Transfers",
    items: [{ size: "22x1 inch", price: 0.3, handling: 2 }],
  },
  {
    title: "UV DTF Transfers",
    items: [{ size: "22x1 inch", price: 0.72, handling: 2 }],
  },
];

const PriceTab = () => {
  return (
    <div className="container">
      <Row>
        {priceData.map((product, index) => (
          <Col md={6} lg={4} className="mb-4" key={index}>
            <Card
              style={{
                backgroundColor: cardColors[index % cardColors.length],
                border: "1px solid #ccc",
                borderRadius: "8px",
                padding: "12px",
                height: "100%",
              }}
            >
              <Card.Body>
                <Card.Title style={{ fontWeight: "bold" }}>
                  {product.title}
                </Card.Title>
                {product.items.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: "10px" }}>
                    <div>
                      <strong>Size:</strong> {item.size}
                    </div>
                    <div>
                      <strong>Price:</strong> ${item.price}
                    </div>
                    <div>
                      <strong>Handling & Box:</strong> ${item.handling}
                    </div>
                    <hr />
                  </div>
                ))}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="mt-5">
  <h5 style={{ fontWeight: "bold" }}>Notes</h5>
  <div style={{ backgroundColor: "#28a745", color: "white", padding: "10px", marginBottom: "10px", borderRadius: "4px" }}>
    For both back and front designs, we charge an additional $1.50.
  </div>
  <div style={{ backgroundColor: "#f9e79f", padding: "10px", marginBottom: "10px", borderRadius: "4px" }}>
    <div>We do not accept any responsibility for errors (except in production) or lost packages.</div>
    <div>Stores are required to pay the full amount.</div>
    <div>Store managers are responsible for making and approving any custom changes.</div>
    <div>If the store owner does not communicate regarding the order, they will be held responsible for any errors or changes.</div>
    <div>All prices are subject to change; we will notify you before making any price changes.</div>
  </div>
  <div style={{ backgroundColor: "#e74c3c", color: "white", padding: "10px", borderRadius: "4px" }}>
    T-shirts must include specific brand and model. Orders are prepared accordingly. If it is Gildan 5000, use that name. If it is Bella Canvas, use that brand name. Others must be written with similar specificity.
  </div>
</div>

    </div>
  );
};

export default PriceTab;
